import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_CLUSTERS_INFO,
	SET_LOADING,
	SET_PROCESSING_RESULT,
	SET_ENODEB_PAIRING_LOADING,
	SET_ENODEB_PAIRING_RESULT
} from '../actions/ScriptsGenerationActions';

const initialState = {
	clustersInfo: [],
	isLoading: false,
	processingResult: null,
	isEnodebPairingLoading: false,
	enodebPairingResult: null,
	formState: {
		values: {
			deploymentDate: new Date(),
			excelInputFile: null,
			enodebPairingExcelFile: null
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const scriptsGenerationReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							formState: {
								...initialState.formState
							},
							processingResult: null,
							enodebPairingExcelFile: null
						};
					}
					case GET_CLUSTERS_INFO: {
						return {
							...state,
							clustersInfo: action.clustersInfo
						};
					}
					case SET_LOADING: {
						return {
							...state,
							isLoading: action.isLoading
						};
					}
					case SET_PROCESSING_RESULT: {
						return {
							...state,
							processingResult: action.result
						};
					}
					case SET_ENODEB_PAIRING_LOADING: {
						return {
							...state,
							isEnodebPairingLoading: action.isLoading
						};
					}
					case SET_ENODEB_PAIRING_RESULT: {
						return {
							...state,
							enodebPairingResult: action.result
						};
					}
					default: {
						return state;
					}
	}
};

export default scriptsGenerationReducer;
